import axios from "axios";

import config from "./config";

var token = window.localStorage.getItem('token');
var token_support = window.localStorage.getItem('token_support');

const CancelToken = axios.CancelToken;
let cancel;

const instance = axios.create({
    baseURL: config.api_endpoint,
    timeout: 500000,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    },
    // cancelToken: new CancelToken(function executor(c) {
    //     cancel = c;
    // }),
});

const instanceSupport = axios.create({
    baseURL: config.api_support,
    timeout: 500000,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token_support}`
    },
    // cancelToken: new CancelToken(function executor(c) {
    //     cancel = c;
    // }),
});

const instanceExport = axios.create({
    baseURL: config.api_export,
    timeout: 20000,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    },
    // cancelToken: new CancelToken(function executor(c) {
    //     cancel = c;
    // }),
});

const instanceUrlencoded = axios.create({
    baseURL: config.api_endpoint,
    timeout: 20000,
    headers: {
        'Accept': 'application/x-www-form-urlencoded',
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Bearer ${token}`
    },
    // cancelToken: new CancelToken(function executor(c) {
    //     cancel = c;
    // }),
});



const checkUserIdentity = () => {
    return instance
        .get('/auth/user')
        .then(res => {
            const { status, data } = res;
            if (status === 200) {
                return {
                    status: true,
                    user: data.data,
                }
            } else {
                return {
                    status: false,
                    error: data,
                }
            }
        })
        .catch(err => {
            return {
                status: false,
                error: err,
            }
        });
}

const logoutWebAPI = () => {
    return instance.post('/auth/logout');
}

const logoutWebSupport = () => {
    return instanceSupport.post('/auth/logout');
}
 
const setToken = (token) => {
    window.localStorage.setItem('token', token);
    instance.defaults.headers.Authorization = `Bearer ${token}`;
}

const setTokenSupport = (token) => {
    window.localStorage.setItem('token_support', token);
    instanceSupport.defaults.headers.Authorization = `Bearer ${token}`;
}

const logout = () => {
    logoutWebAPI();
    logoutWebSupport();
    token = null;
    token_support = null;
    // window.localStorage.clear();
}

export default {
    fetch: instance,
    fetchSupport: instanceSupport,
    fetchExport: instanceExport,
    fetchUrlEncoded: instanceUrlencoded,
    setToken,
    setTokenSupport,
    logout,
    checkUserIdentity,
    cancel,
}